import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField
} from 'react-admin';

function ExponentePodcastList(props: any) {
  useEffect(() => {
    document.title = 'Listado de Exponentes de Podcast';
  }, []);

  return (
    <List {...props}>
      <Datagrid>
        <FunctionField
          source="imagen"
          render={(record: any) => (
            <img
              src={record.imagen.url}
              alt={record.imagen.alternativeText}
              style={{ width: '50px', height: 'auto' }}
            />
          )}
        />
        <TextField source="nombre" />
        <TextField source="empresa" />
        <TextField source="cargo" />
      </Datagrid>
    </List>
  )
}

export default ExponentePodcastList